import { Action, createReducer, on } from '@ngrx/store'
import { MetricDetailState } from '../state/metric-detail.state'
import {
  purgeMetricDetail,
  setMetricDetailContext,
  setMetricDetailItems,
  setMetricDetailLoader,
  setMetricDetailSourceMetric
} from '@features/metric-detail/store/actions/metric-detail.actions'

export const initialState: MetricDetailState = {
  metricContext: undefined,
  displayMode: undefined,
  sourceMetric: undefined,
  metricToDetailed: undefined,
  items: undefined,
  loading: undefined
}

const reducer = createReducer(
  initialState,
  on(setMetricDetailContext, (state, { metricContext, displayMode, metricToDetailed }) => ({
    ...state,
    metricContext,
    displayMode,
    metricToDetailed
  })),
  on(setMetricDetailSourceMetric, (state, { sourceMetric }): MetricDetailState => ({ ...state, sourceMetric })),
  on(setMetricDetailItems, (state, { items }): MetricDetailState => ({ ...state, items })),
  on(setMetricDetailLoader, (state, { loading }): MetricDetailState => ({ ...state, loading })),
  on(purgeMetricDetail, (): MetricDetailState => ({ ...initialState }))
)

export const metricDetailReducer = (state: MetricDetailState | undefined, action: Action): MetricDetailState =>
  reducer(state, action)
